import { render, staticRenderFns } from "./ViewPassword.vue?vue&type=template&id=455ffbf5&"
import script from "./ViewPassword.vue?vue&type=script&lang=js&"
export * from "./ViewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports